import { useFetch } from './useFetch';
export const useUserPreferences = () => {
    const { get, put } = useFetch();
    const getPreferences = async () => {
        const preferences = await get('/user-preferences');
        return {
            collapseSidebar: preferences.collapseSidebar === 'so' ? false : true,
            useNewDesign: preferences.useNewDesign === 'yes' ? true : false,
        };
    };
    const updateCollapsePreference = async (selection) => {
        const result = await put('/user-preferences', { collapseSidebar: selection });
        return result.updatedSidebar;
    };
    const updateOfficeSelection = async (offices) => {
        const data = await put('/user-preferences', { selectedOffices: offices });
        return data?.updatedOffices;
    };
    const updateDesignPreference = async (useNewDesign) => {
        const data = await put('/user-preferences', { useNewDesign: useNewDesign ? 'yes' : 'no' });
        return data.updatedDesign;
    };
    const updatePreference = async (prefs) => await put('/user-preferences', prefs);
    return { getPreferences, updateCollapsePreference, updateOfficeSelection, updateDesignPreference, updatePreference };
};
